export default () => {
  /**
   * Initial menu for mobile
   */
  let submenu              = document.querySelector('.sub-menu');
  let mainHeader           = document.querySelector('.mainHeader');
  let subMenuToggle        = document.querySelectorAll('.sub-menu-toggle');
  let menuItemWithChildren = document.querySelectorAll('.menu-item-has-children');
  let menuToggleElem       = document.querySelector('.mainHeader__menuToggleIcon');
  let body                 = document.querySelector('body');
  let menuToggle           = false;
  let menuItemCurrentClass = "current-menu-item";

  let menuIconOpen  = "icon-menu";
  let menuIconClose = "icon-cross";

  //toggle next submenu element
  menuItemWithChildren.forEach(item => {
    item.addEventListener('click', e => {
      e.currentTarget.classList.toggle('sub-menu-active');
    });
  });

  //toggle menu icon
  menuToggleElem?.addEventListener('click', e => {
    e.currentTarget.classList.toggle(menuIconOpen);
    e.currentTarget.classList.toggle(menuIconClose);
    mainHeader.classList.toggle('menu-open');
    body.classList.toggle('menu-open');
  });
}